import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Colors, TextFont } from "../../config";
import { REASON_FOR_CANCELLATION, Text } from "../../config/Constants";
import Button from "../Button";
import Modal from "../Modal";
import SelectField from "../SelectField";
import TextArea from "../TextArea";
import { useNavigate, useParams } from "react-router-dom";
import {
  cancelBooking,
  getDropdownsForReason,
} from "../../services/bookingServices";
import { toast } from "react-toastify";
import { ToastMessage } from "../ToastMessage";
import { formatReasonDropdown } from "../../helper";
import { cancelBizBooking } from "../../services/bizBookingService";
const closeIcon = require("../../assets/images/close.png");

const CancelTicketModal = ({
  setClose,
  setBackendErrorMsg,
  isBusinessTrip,
  reqId
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [reasonSelected, setReasonSelected] = useState("");
  const [comment, setComment] = useState("");
  const disableCondition = !(reasonSelected && comment);
  const [reasonDropdowns, setReasonDropdowns] = useState([]);
  const [loader, setLoader] = useState(false);

  const fetchReason = async () => {
    try {
      const { data } = await getDropdownsForReason();
      console.log("response", data);
      if (data.code === 200) {
        let formattedData = formatReasonDropdown(
          data?.data?.cancellation_reasons,
        );
        setReasonDropdowns(formattedData);
      }
    } catch (error) {
      console.log("error");
    }
  };

  const handleSubmit = async () => {
    setLoader(true);
    console.log(reasonSelected, comment);
    const data = {
      cancelReason: reasonSelected,
      comments: comment,
    };
    try {
      const response = isBusinessTrip
        ? await cancelBizBooking(reqId, data)
        : await cancelBooking(id, data);
      console.log(response);
      if (response.status === 200) {
        const responseData = response.data.data;
        console.log("responseData", responseData);
        setClose();
        navigate("/user/bookings");
        toast.success(<ToastMessage message={response.data.message} />);
      }
    } catch (error) {
      console.log(error);
      setClose();
      setBackendErrorMsg(error.message);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchReason();
  }, []);

  return (
    <>
      <Modal setClose={setClose}>
        <CancelTicketContainer>
          <TicketHeader>
            <HeaderLabel>
              <TextFont
                fontColor={Colors.brandOne}
                fontWeight="700"
                fontSize="1.375rem"
              >
                {Text.cancelTickets}
              </TextFont>
            </HeaderLabel>
            <CloseIcon src={closeIcon} alt="close" onClick={setClose} />
          </TicketHeader>
          <TicketBody>
            <SelectField
              label={Text.reasonForCancellation}
              data={reasonDropdowns}
              isRounded
              value={reasonSelected}
              onChange={(e) => {
                setReasonSelected(e.target.value);
              }}
              required
            />
            <TextArea
              label="Comment"
              placeholder={Text.enterComment}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              required
            />
            <ButtonWrapper>
              <Button
                label={loader ? "Submitting..." : Text.submit}
                onClick={handleSubmit}
                bgColor={Colors.pomegranate}
                topBottomPadding="0.875rem"
                fontSize="1rem"
                fontWeight="400"
                disabled={disableCondition || loader}
              />
            </ButtonWrapper>
          </TicketBody>
        </CancelTicketContainer>
      </Modal>
    </>
  );
};

export default CancelTicketModal;

const CancelTicketContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 2rem;
  gap: 1.5rem;
  width: 18.75rem;
  @media only screen and (max-width: 500px) {
    width: 15.625rem;
  }
`;
const TicketHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const HeaderLabel = styled.div`
  width: 95%;
  display: flex;
  justify-content: center;
`;
const TicketBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 500px) {
    gap: 1rem;
  }
`;
const CloseIcon = styled.img`
  cursor: pointer;
`;
const ButtonWrapper = styled.div`
  width: 16.75rem;
  margin: auto;
  @media only screen and (max-width: 500px) {
    width: 12.5rem;
  }
`;
